export interface LeftNavUpsellState {
    isHidden: boolean;
    url: string;
    datapointNameShow: string;
    datapointNameClicked: string;
    buttonText: string;
    buttonTextLine2: string;
    buttonIconPath: string;
    buttonIconType: ButtonIconType;
}

export enum ButtonIconType {
    SvgIcon,
    FabricIcon,
}
